import { createFileRoute } from '@tanstack/react-router'
import { AIAgentDetailPage } from '@/pages/ai-agent-detail'

export const Route = createFileRoute('/_authenticated/ai/$agentKey')({
  staticData: { title: 'AI Agent' },
  component: AIAgentDetailRoute,
})

function AIAgentDetailRoute() {
  const { agentKey } = Route.useParams()
  return <AIAgentDetailPage agentKey={agentKey} />
}
